import React from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/style/colors";
import TitleDescriptionCard from "../generic/TitleDescriptionCard";
import { ReactComponent as ForkIcon3Long } from "../../assets/icons/Fork3Long.svg";
import { ReactComponent as ForkIcon4Long } from "../../assets/icons/Fork4Long.svg";
import { useNavigate } from "react-router-dom";

const PlatformMobileData = () => {
  const navigate = useNavigate();
  const block1 = [
    {
      title: "Track Every Install & Reactivation",
      description:
        "Clearly attribute app installs, reinstalls, and user reactivations directly to your campaigns and channels.",
      learnMore: () => navigate("/measure"),
    },

    {
      title: "Smart Deep Linking",
      description:
        "Deliver frictionless user journeys with links that intelligently route users straight to the content they expect, even after installation.",
      learnMore: () => navigate("/engagement"),
    },

    {
      title: "Automated Messaging",
      description:
        "Automatically display relevant in-app, push, and inbox messages separately tailored for new and existing users.",
      learnMore: () => navigate("/messaging"),
    },
  ];
  const block2 = [
    {
      title: "Optimize Ad Performance",
      description:
        "Clearly identify top-performing ads and campaigns, reallocating budgets efficiently.",
      learnMore: () => navigate("/measure"),
    },

    {
      title: "Boost User Retention",
      description:
        "Personalized messaging and streamlined onboarding experiences keep users coming back.",
      learnMore: () => navigate("/engagement"),
    },

    {
      title: "Easily Measure Impact",
      description:
        "One unified dashboard for quick, actionable insights into mobile user behavior and campaign performance.",
      learnMore: () => navigate("/analyse"),
    },
  ];
  return (
    <FullPageContainer>
      <Container>
        <Content>
          <TextWrapper>
            <Title>Mobile Growth Made Simple</Title>
          </TextWrapper>
          <RightSide>
            <ForkWrapper>
              <ForkIcon3Long
                color={lightThemeColors.landingPagePrimaryBackground}
              />
            </ForkWrapper>
            <ItemsWrapper>
              {block1.map((item, index) => (
                <TitleDescriptionCard
                  key={index}
                  title={item.title}
                  description={item.description}
                  learnMore={item.learnMore}
                />
              ))}
            </ItemsWrapper>
          </RightSide>
        </Content>
        <Content>
          <TextWrapper>
            <Title>Maximize ROI and User Lifetime Value</Title>
          </TextWrapper>
          <RightSide>
            <ForkWrapper>
              <ForkIcon3Long
                color={lightThemeColors.landingPagePrimaryBackground}
              />
            </ForkWrapper>
            <ItemsWrapper>
              {block2.map((item, index) => (
                <TitleDescriptionCard
                  key={index}
                  title={item.title}
                  description={item.description}
                  learnMore={item.learnMore}
                />
              ))}
            </ItemsWrapper>
          </RightSide>
        </Content>
      </Container>
    </FullPageContainer>
  );
};

export default PlatformMobileData;
const FullPageContainer = styled.div`
  display: flex;
  width: 100%;
  background: ${lightThemeColors.background};
  position: relative;
`;

const Container = styled.div`
  width: 100%;
  max-width: 1512px;
  margin-left: auto;
  margin-right: auto;
  z-index: 1;
  display: flex;
  flex-direction: column;
padding:100px 80px;
  gap: 100px;
  @media (max-width: 990px) {
    padding: 20px;
    gap: 30px;
  }
`;
const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  gap: 30px;
  align-items: center;
  @media (max-width: 990px) {
    flex-direction: column;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  gap: 30px;
  max-width: 850px;
`;

const Title = styled.h1`
  color: ${lightThemeColors.darkColor};
  font-size: 36px;
  font-weight: 700;
  line-height: 46px;
  @media (max-width: 990px) {
    font-size: 30px;
    line-height: 36px;
    text-align: center;
  }
`;

const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
    gap: 20px;
  overflow: hidden;

`;
const RightSide = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  gap: 10px;
`;
const ForkWrapper = styled.div`
display:flex;
align-items:center;
height:100%;
  @media (max-width: 990px) {
    display: none;
  }
`;
